import * as React from "react";
import { Card, CardTitle, CircularProgress, Button } from 'react-md';
import { observer } from "mobx-react";
import { observable, computed, action, runInAction } from "mobx";
import "./static/OverviewAnalytics.scss";
import { isNullOrUndefined } from "util";
import BaseComponent from "../../../utility/BaseComponent";
import { IServicesProvider } from "../../../di/IServicesProvider";
import { ActivityLogItem } from "../../../utility/admin/UsersControls/UsersAnalytics/IUsersAnalytics";
import { BrowserHistroy, withRouter } from "react-router-dom";
import { IBaseModel } from "../../../utility/IBaseModel";
import * as moment from 'moment';

export class OverviewAnalyticsModel implements IBaseModel {
    
    @observable asyncOperationsCount: number = 0;
    @observable usersCount: number = 0;
    @observable usersPerMonthMap: Map<string, number>;
    @observable activityLog: ActivityLogItem[] = [];
    @computed get usersThisMonth() {
        let currentDate = moment().toDate();
        let count = 0;
        if (!isNullOrUndefined(this.usersPerMonthMap)) {
            let existing = this
            .usersPerMonthMap
            .get(`${currentDate.getMonth()} ${currentDate.getFullYear()}`);
            if (!isNullOrUndefined(existing)) {
                count += existing;
            }
        }
        return count;
    }
    @observable resultsCount: number = 0;
    @observable resultsPerMonthMap: Map<string, number>;
    private servicesProvider: IServicesProvider;

    @computed get resultsThisMonth() {
        let currentDate = moment().toDate();
        let count = 0;
        if (!isNullOrUndefined(this.resultsPerMonthMap)) {
            let existing = this
            .resultsPerMonthMap
            .get(`${currentDate.getMonth()} ${currentDate.getFullYear()}`);
            if (!isNullOrUndefined(existing)) {
                count += existing;
            }
        }
        return count;
    }
    @action.bound
    incrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
    }
    @action.bound
    decrementAsyncOperations() {
        this.asyncOperationsCount = this.asyncOperationsCount - 1;
    }
    
    constructor(servicesProvider: IServicesProvider) {
        this.servicesProvider = servicesProvider;
    }

    @action prepare() {
        this.incrementAsyncOperations();
        this.servicesProvider.getAdminServicesProvider()
        .getUsersControls().getAnalytics()
        .subscribe( result => {
            if (this.asyncOperationsCount > 0) {
                this.decrementAsyncOperations();
            }
            runInAction( () => {
                this.usersCount = result.getUsersCount();
                this.usersPerMonthMap = result.getUserCountPerMonth();
                this.resultsCount = result.getSubmittedResultsCount();
                this.resultsPerMonthMap = result.getSubmittedResultsCountPerMonth();
                this.activityLog = result.getActivityLog();
        
            });
        });
        
    }
}

@observer class OverviewAnalytics extends BaseComponent<{model: OverviewAnalyticsModel, history: BrowserHistroy}, {}> {
    
    render() {
        return (
            <div className="OverviewAnalyticsContainer" >
                <Card className="OverviewAnalyticsCard">
                    <CardTitle title="Users" subtitle="Overall Users Stats" />
                    <div className="OverviewAnalyticsCardContents">
                        <div>
                            <div className='AnalyticsContentWrapper'>
                                <h4>New This Month</h4>
                                {
                                    this.props.model.asyncOperationsCount !== 0 && 
                                    <CircularProgress centered={true} id="Progress" />
                                }
                                {
                                    this.props.model.asyncOperationsCount === 0 && 
                                    <h2>{this.props.model.usersThisMonth}</h2>
                                }
                            </div>
                        </div>
                        <div>
                            <div className='AnalyticsContentWrapper'>
                                <h4>Total Users</h4>
                                {
                                    this.props.model.asyncOperationsCount !== 0 && 
                                    <CircularProgress centered={true} id="Progress" />
                                }
                                {
                                    this.props.model.asyncOperationsCount === 0 && 
                                    <h2>{this.props.model.usersCount}</h2>
                                }
                            </div>
                        </div>
                    </div>
                    <Button 
                        className="OverviewAnalyticsCardAction"
                        flat={true} 
                        secondary={true}  
                        onClick={() => this.props.history.push("/admin/users")}
                    >
                    View More
                    </Button>                  
                </Card>
                <Card className="OverviewAnalyticsCard">
                    <CardTitle title="Results" subtitle="Overall Results Stats" />
                    <div className="OverviewAnalyticsCardContents">
                        <div>
                            <div className='AnalyticsContentWrapper'>
                                <h4>Submitted This Month</h4>
                                {
                                    this.props.model.asyncOperationsCount !== 0 && 
                                    <CircularProgress centered={true} id="Progress" />
                                }
                                {
                                    this.props.model.asyncOperationsCount === 0 && 
                                    <h2>{this.props.model.resultsThisMonth}</h2>
                                }
                            </div>
                        </div>
                        <div>
                            <div className='AnalyticsContentWrapper'>
                                <h4>Total Submitted</h4>
                                {
                                    this.props.model.asyncOperationsCount !== 0 && 
                                    <CircularProgress centered={true} id="Progress" />
                                }
                                {
                                    this.props.model.asyncOperationsCount === 0 && 
                                    <h2>{this.props.model.resultsCount}</h2>
                                }
                            </div>
                        </div>
                    </div>
                    <Button 
                        className="OverviewAnalyticsCardAction"
                        flat={true} 
                        secondary={true}  
                        onClick={() => this.props.history.push("/admin/results")}
                    >
                    View More
                    </Button>
                </Card>
            </div>
        );
    }
}

export default withRouter(OverviewAnalytics);


// WEBPACK FOOTER //
// ./src/view/Admin/OverviewAnalytics/OverviewAnalytics.tsx